import './FieldError.scss';

import React, { PureComponent } from 'react';

import cxHelpers from 'util/className';

@cxHelpers('FieldError')
export default class FieldError extends PureComponent {
  render() {
    return <div {...this.props} className={this.cx()} />;
  }
}
